import { forwardRef } from 'react';
import React from 'react';
import { Button } from './Button';
export const PrimaryButton = forwardRef(({ colorVariant, className, children, ...rest }, ref) => {
    return (React.createElement(Button, { className: `cb-primary-button cb-text-2${colorVariant === 'error' ? ` cb-primary-button-error-variant` : ''}${className ? ` ${className}` : ''}`, spinnerClassName: 'cb-primary-button-spinner', ref: ref, children: children, ...rest }));
});
